import { useState, useEffect } from 'react';
import axios from 'axios';

export const useActiveModules = () => {
  const [activeModules, setActiveModules] = useState([]);
  const [activeModulesIds, setActiveModulesIds] = useState([]);
  const [activeModulesLoading, setActiveModulesLoading] = useState(true);
  const [activeModulesError, setActiveModulesError] = useState(null);

  useEffect(() => {
    const fetchModules = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/api/get_active_modules`,
          {}
        );
        
        const sortedModules = response.data.sort((a, b) => a.module_seq - b.module_seq);
        setActiveModules(sortedModules);
        setActiveModulesIds(sortedModules.map(m => m.module_id));
        setActiveModulesLoading(false);
      } catch (err) {
        console.error('Error fetching modules:', err);
        setActiveModulesError(err);
        setActiveModulesLoading(false);
      }
    };

    fetchModules();
  }, []);

  return { activeModules, activeModulesIds, activeModulesLoading, activeModulesError };
};